import { Card, CardContent, Grid } from "@mui/material";
import { PlayArrow, Pause, PlayCircle } from "@mui/icons-material";
import { useRef, useState } from "react";

const focusVideoStyle = {
    width: '100%',
    margin: 5,
    borderRadius: 16,
    boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
    display: 'block',
    background: '#000',
}

const thumbWrapStyle = {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    borderRadius: 10,
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
    transition: 'transform 0.18s ease-out, box-shadow 0.18s ease-out',
    cursor: 'pointer',
}

// Seeking a hair into the clip forces the browser to decode a real frame
// instead of showing a blank/black box for videos that never autoplay.
const showFirstFrame = (e) => {
    try { e.target.currentTime = 0.1 } catch { /* ignore */ }
}

export const MediaDisplayGallery = ({mediaList}) => {
    const [focusMedia, setFocusMedia] = useState('')
    const [isPlaying, setIsPlaying] = useState(true)
    const focusVideoRef = useRef(null)
    let placeholder_img = mediaList[0]
    let preview_style = {width:80, height:80, objectFit:'cover'}

    const togglePlay = () => {
        const el = focusVideoRef.current
        if (!el) return
        if (el.paused) { el.play(); setIsPlaying(true) }
        else { el.pause(); setIsPlaying(false) }
    }

    return (
        <>
        {mediaList.length > 0 ?
        <>
        <Card>
            <CardContent>
                {focusMedia?.includes("mp4") ?
                    <div style={{position:'relative'}}>
                        <video
                            ref={focusVideoRef}
                            key={focusMedia}
                            style={focusVideoStyle}
                            autoPlay
                            muted
                            loop
                            playsInline
                            onClick={togglePlay}
                            onPlay={() => setIsPlaying(true)}
                            onPause={() => setIsPlaying(false)}
                        >
                            <source src={focusMedia} type="video/mp4" />
                        </video>
                        <div
                            onClick={togglePlay}
                            style={{
                                position: 'absolute',
                                bottom: 16,
                                right: 16,
                                width: 40,
                                height: 40,
                                borderRadius: '50%',
                                background: 'rgba(0,0,0,0.5)',
                                backdropFilter: 'blur(6px)',
                                color: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                transition: 'background 0.15s ease',
                            }}
                            onMouseOver={e => e.currentTarget.style.background = 'rgba(0,0,0,0.7)'}
                            onMouseOut={e => e.currentTarget.style.background = 'rgba(0,0,0,0.5)'}
                        >
                            {isPlaying ? <Pause fontSize="small" /> : <PlayArrow fontSize="small" />}
                        </div>
                    </div>
                    : focusMedia ?
                    <img style={{width:'100%', margin:5, borderRadius:16, boxShadow:'0 8px 24px rgba(0,0,0,0.18)'}} alt="Community Pic" src={focusMedia} />
                    :
                    ""
                }
                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    {mediaList.map((media, i) =>
                        media.url.includes("mp4") ?
                        <Grid key={i} item xs={2} sm={4} md={4} onClick={() => setFocusMedia(media.url)}>
                            <div
                                style={{...thumbWrapStyle, width:80, height:80, position:'relative'}}
                                onMouseOver={e => { e.currentTarget.style.transform = 'scale(1.05)'; e.currentTarget.style.boxShadow = '0 4px 14px rgba(0,0,0,0.22)' }}
                                onMouseOut={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.12)' }}
                            >
                                <video muted playsInline preload="metadata" onLoadedMetadata={showFirstFrame} style={{...preview_style, position:'absolute', inset:0}}>
                                    <source src={media.url} type="video/mp4" />
                                </video>
                                <div style={{
                                    position: 'absolute',
                                    inset: 0,
                                    background: 'rgba(0,0,0,0.25)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#fff',
                                }}>
                                    <PlayCircle fontSize="medium" />
                                </div>
                            </div>
                        </Grid>
                        :
                        <Grid key={i} item xs={2} sm={4} md={4} onClick={() => setFocusMedia(media.url)}>
                        <div
                            style={thumbWrapStyle}
                            onMouseOver={e => { e.currentTarget.style.transform = 'scale(1.05)'; e.currentTarget.style.boxShadow = '0 4px 14px rgba(0,0,0,0.22)' }}
                            onMouseOut={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.12)' }}
                        >
                        <img
                            src={media.url}
                            alt={'Community Gallery'}
                            loading="lazy"
                            onLoad={e => {
                                if(e.target.height < 10) e.target.src = placeholder_img
                            }}
                            style={preview_style}
                            onError={(e) => {
                                e.target.style.textAlign = 'center';
                                e.target.style.background = 'url('+placeholder_img+')';
                                e.target.style.backgroundSize = 'contain';
                                e.target.style.backgroundRepeat = 'no-repeat';
                                if(e.currentTarget.src !== placeholder_img)
                                    e.target.src = placeholder_img
                                }}
                        />
                        </div>
                        </Grid>
                    )}

                </Grid>
            </CardContent>
        </Card>
        </>
        :
        ""
        }
        </>
    )
}
